import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import SkeletonImage from "components/Skeleton/Image";
import styles from "./styles.module.scss";

const ImageSlide = (props) => {
  const { className, ...restProps } = props;

  return (
    <SkeletonImage
      skeletonClassName={styles.slideSkeleton}
      className={cn(styles.slide, className)}
      // Acceptable use of props spreading here as this is just a wrapper.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  );
};

ImageSlide.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  loading: PropTypes.oneOf(["eager", "lazy"]),
  onClick: PropTypes.func,
};

ImageSlide.defaultProps = {
  className: "",
  loading: "eager",
  onClick: () => {},
  src: "",
};

export default ImageSlide;
